import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Flex, FlexProps, Text } from '@modusign/design-system';
import { forwardRef } from 'react';

import { useGNBFoldHandle } from '@app/containers/GlobalNavigationBar/GNBFoldHandleContext';
import { useColorScheme } from '@app/hooks/useColorScheme';

const GNBPrimaryButton = forwardRef(
  ({ children, disabled, ...props }: FlexProps<'button'>, ref: React.Ref<HTMLButtonElement>) => {
    const { folded } = useGNBFoldHandle();
    const { theme } = useColorScheme();

    return (
      <Flex
        alignItems="center"
        as="button"
        backgroundColor={
          disabled ? theme.gnb.ctaButton.background.disabled : theme.gnb.ctaButton.background.active
        }
        border="1px solid"
        borderColor={disabled ? 'buttonBorderNeutralBase' : 'buttonBorderPrimaryBase'}
        borderRadius={folded ? '100%' : '3px'}
        boxShadow="0px 3px 2px -2px rgba(0, 0, 0, 0.18)"
        className="tagGNBContractSetupStartBtn"
        color={disabled ? 'textNeutralUltraLight' : 'textNeutralBase'}
        data-testid="gnbPrimaryButton"
        disabled={disabled}
        height={folded ? 56 : 36}
        justifyContent="center"
        py={folded ? 3 : 0}
        ref={ref}
        width={folded ? 56 : '100%'}
        {...props}
      >
        {folded ? (
          <Box as={FontAwesomeIcon} icon={faPaperPlane} width="18px" />
        ) : (
          <Text fontWeight="medium">{children}</Text>
        )}
      </Flex>
    );
  }
);

export default GNBPrimaryButton;
